import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const EyeHiddenIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M16.0068 8.20697C16.9422 9.18158 17.5002 10 17.5002 10C17.5002 10 14.0911 15 10.0002 15C9.74133 15 9.49013 14.9887 9.24646 14.9673L16.0068 8.20697Z"
        {...svgAttrs}
      />
      <path
        opacity="0.3"
        d="M12.0876 5.41238L10 7.5C8.61929 7.5 7.5 8.61929 7.5 10L4.60551 12.8945C3.12505 11.5279 2.5 10 2.5 10C2.5 10 4.54545 5 10 5C10.7221 5 11.423 5.15579 12.0876 5.41238Z"
        {...svgAttrs}
      />
      <path
        d="M15.446 4.16669L4.25012 15.3625L5.42863 16.5411L16.6245 5.3452L15.446 4.16669Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default EyeHiddenIcon;
